(() => {
  const CUSTOM_LAUNCHER_SELECTOR = '.chat-js';
  const REVEAL_THRESHOLD = 10;
  let zendeskLoaderPromise = null;

  window.zESettings = window.zESettings || {
    webWidget: {
      launcher: {
        customLauncherSelector: CUSTOM_LAUNCHER_SELECTOR,
      },
    },
  };

  function hideZendeskDefault() {
    try {
      if (typeof window.zE === 'function') {
        window.zE('messenger:on', 'booted', () => window.zE('messenger', 'hide'));
      }
    } catch (error) {
      console.warn('[Zendesk] Unable to hide default widget.', error);
    }
  }

  function ensureZendeskLoaded(url) {
    if (zendeskLoaderPromise) return zendeskLoaderPromise;
    if (!url) return Promise.resolve();

    zendeskLoaderPromise = new Promise((resolve) => {
      const script = document.createElement('script');
      script.id = 'ze-snippet';
      script.src = url;
      script.async = true;
      script.onload = () => {
        hideZendeskDefault();
        resolve();
      };
      script.onerror = (error) => {
        console.warn('[Zendesk] Failed to load messenger.', error);
        resolve();
      };
      document.head.appendChild(script);
    });

    return zendeskLoaderPromise;
  }

  function updatePosition(helper, isProductPage) {
    const isMobile = window.matchMedia('(max-width:767px)').matches;
    if (isMobile && isProductPage) {
      helper.style.bottom = '120px';
      helper.style.right = '30px';
    } else {
      helper.style.bottom = '20px';
      helper.style.right = '20px';
    }
  }

  function updateVisibility(helper, menu, button) {
    if (window.scrollY > REVEAL_THRESHOLD) {
      helper.classList.add('visible');
    } else {
      helper.classList.remove('visible');
      if (menu) menu.classList.remove('visible');
      if (button) button.innerHTML = '<span>ajuda?</span>';
    }
  }

  function openZendeskMessenger(url) {
    const attemptOpen = () => {
      try {
        if (typeof window.zE === 'function') {
          window.zE('messenger', 'show');
          window.zE('messenger', 'open');
          return;
        }
      } catch (error) {
        console.warn('[Zendesk] Messenger open failed, retrying.', error);
      }
      setTimeout(attemptOpen, 500);
    };

    ensureZendeskLoaded(url).then(attemptOpen);
  }

  function init() {
    if (window.matchMedia('(max-width: 767px)').matches) return;

    const helper = document.getElementById('helper-chat');
    if (!helper) return;

    const button = helper.querySelector('.helper-chat__bt.help');
    const menu = document.getElementById('helper-menu');
    const chatLink = helper.querySelector(CUSTOM_LAUNCHER_SELECTOR);
    const isProductPage = !!document.querySelector('.shopify-section--main-product');
    const zendeskScriptUrl = helper.dataset.zendeskUrl || '';

    updatePosition(helper, isProductPage);
    updateVisibility(helper, menu, button);

    window.addEventListener('resize', () => updatePosition(helper, isProductPage));
    window.addEventListener('scroll', () => updateVisibility(helper, menu, button), { passive: true });

    if (button && menu) {
      button.addEventListener('click', () => {
        const opened = menu.classList.toggle('visible');
        button.innerHTML = opened ? '<span>X</span>' : '<span>ajuda?</span>';
        if (opened) {
          ensureZendeskLoaded(zendeskScriptUrl);
        }
      });
    }

    if (chatLink) {
      chatLink.addEventListener('click', (event) => {
        event.preventDefault();
        menu?.classList.remove('visible');
        openZendeskMessenger(zendeskScriptUrl);
      });
      chatLink.addEventListener('mouseenter', () => ensureZendeskLoaded(zendeskScriptUrl), { once: true });
      chatLink.addEventListener('focus', () => ensureZendeskLoaded(zendeskScriptUrl), { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
